import React from 'react';
import {
  Dialog, DialogContent, Box, Typography, Card, CardContent, DialogActions,
} from '@material-ui/core';
import { useStyles, Button } from './styles';

const ChangeDialog = (props) => {
  const { openResult, onCloseResult, result } = props;
  const classes = useStyles();

  return (
    <Dialog open={openResult} onClose={onCloseResult} fullWidth maxWidth="md">
      <DialogContent className={classes.cardContent}>
        <Box className={classes.mainBoxes}>
          <Typography className={classes.mainTitle}>Actual</Typography>
          <Box>
            <Card className={classes.leftCards}>
              <CardContent>
                <Typography className={classes.title}>Titulo</Typography>
                <Typography className={classes.texts}>
                  {result.entrada_actual?.titulo}
                </Typography>
              </CardContent>
            </Card>
            <Card className={classes.leftCards}>
              <CardContent>
                <Typography className={classes.title}>Resumen</Typography>
                <Typography className={classes.texts}>
                  {result.entrada_actual?.resumen}
                </Typography>
              </CardContent>
            </Card>
            <Card className={classes.leftCards}>
              <CardContent>
                <Typography className={classes.title}>Detalles</Typography>
                <Typography className={classes.texts}>
                  {result.entrada_actual?.detalle}
                </Typography>
              </CardContent>
            </Card>
            <Card className={classes.leftCards}>
              <CardContent>
                <Typography className={classes.title}>Indicadores</Typography>
                <Typography className={classes.texts}>
                  {result.entrada_actual?.indicadores}
                </Typography>
              </CardContent>
            </Card>
          </Box>
        </Box>
        <Box className={classes.mainBoxes}>
          <Typography className={classes.mainTitle}>Cambio</Typography>
          <Box>
            <Card className={classes.leftCards}>
              <CardContent>
                <Typography className={classes.title}>Titulo</Typography>
                <Typography className={classes.texts}>
                  {result.titulo}
                </Typography>
              </CardContent>
            </Card>
            <Card className={classes.leftCards}>
              <CardContent>
                <Typography className={classes.title}>Resumen</Typography>
                <Typography className={classes.texts}>
                  {result.resumen}
                </Typography>
              </CardContent>
            </Card>
            <Card className={classes.leftCards}>
              <CardContent>
                <Typography className={classes.title}>Detalle</Typography>
                <Typography className={classes.texts}>
                  {result.detalle}
                </Typography>
              </CardContent>
            </Card>
            <Card className={classes.leftCards}>
              <CardContent>
                <Typography className={classes.title}>Indicadores</Typography>
                <Typography className={classes.texts}>
                  {result.indicadores}
                </Typography>
              </CardContent>
            </Card>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCloseResult} width="fullWidth">Cerrar</Button>
      </DialogActions>

    </Dialog>
  );
};

export default ChangeDialog;
